import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.FooterPreviewTemplate) => (
    <PageSkeleton title="Nav preview" footer_override={props.model.body}>
        <h1>{t`Hello World!`}</h1>
    </PageSkeleton>
);
